<template>
    <div>

        <therapist-dash-intro v-if="part.type == 'intro'"
                             :part="part"
                             :do_refresh="do_refresh"></therapist-dash-intro>

        <therapist-dash-schedule-new v-else-if="part.type == 'bookings'"
                                :part="part"
                                :initial-date="initialDate"
                                :is_admin="is_admin"
                                :do_refresh="do_refresh"></therapist-dash-schedule-new>

        <div v-else class="card">
            <div class="card-header">
                KOMPONENTTYP OREGISTRERAD
            </div>
            <div class="card-body">
                Okänd komponenttyp:
                <div><b>{{part.title}}</b></div>
                <div><b>{{part.type}}</b></div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: [
            'part',
            'do_refresh',
            'initialDate',
            'is_admin',
        ],
        name: "therapist-create-dash-component"
    }
</script>

<style scoped>

</style>
